import { useContext, useEffect, useState } from 'react';
import { ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import SelectionItem from '../../types/selection-item';
import Operations from '../../constants/operations';
import { GameDocument } from '../../types/game-document';
import { ArgumentList } from './argument-list';
import {
  GetZones,
  GetTasks,
  GetTimers,
  GetDocumentAreas,
  GetTaskTitle,
  GetZoneTitle,
  GetAreaTitle,
  GetTimerTitle,
  GetItems,
  GetItemTitle,
  GetTitles,
  GetTitle
} from '../../utils/game-document/assets/index';
import { GameDocumentContext } from '../../contexts/game-document';
import ComboboxInput from '../forms/combobox-input';

interface ArgumentProps {
  onChangeOperation?: (operationName?: string) => void;
  onChangeArgument?: (selectedArguments?: string | string[]) => void;
  onChangeQuantity?: (quantity?: number) => void;
  disabled?: boolean;
}
export const GameAlgorithm = ({
  onChangeOperation = () => {},
  disabled = false,
  ...props
}: ArgumentProps) => {
  const [selectedList, setSelectedList] = useState<string>('');
  const [showQuantity, setShowQuantity] = useState<boolean>(false);
  const [argumentList, setArgumentList] = useState<SelectionItem[] | undefined>(
    []
  );
  const [state] = useContext(GameDocumentContext);
  const gameDocument = state.gameDocument;

  const handleChange = (e: ComboBoxChangeEvent) => {
    let res = e.target.value;
    if (res !== null) {
      setSelectedList(res.list);
      setShowQuantity(res.showQuantity);
      onChangeOperation(res.name);
      setArgumentList(getArgumentList(res.list, gameDocument));
    } else {
      setSelectedList('');
      setShowQuantity(false);
      onChangeOperation('');
      setArgumentList([]);
    }
  };

  const getArgumentList = (
    listName: string | undefined,
    gameDocument: GameDocument | undefined
  ) => {
    switch (listName) {
      case 'zone':
        return (GetZones(gameDocument) ?? []).map((z) => ({
          ...z,
          name: GetZoneTitle(gameDocument, z.id)
        })) as SelectionItem[];
      case 'task':
        return (GetTasks(gameDocument) ?? []).map((t) => ({
          ...t,
          name: GetTaskTitle(gameDocument, t.id)
        })) as SelectionItem[];
      case 'area':
        return (GetDocumentAreas(gameDocument) ?? []).map((a) => ({
          ...a,
          name: GetAreaTitle(gameDocument, a.id)
        })) as SelectionItem[];
      case 'item':
        return (GetItems(gameDocument) ?? []).map((i) => ({
          ...i,
          name: GetItemTitle(gameDocument, i.id)
        })) as SelectionItem[];
      case 'title':
        return (GetTitles(gameDocument) ?? []).map((t) => ({
          ...t,
          name: GetTitle(gameDocument, t.id)
        })) as SelectionItem[];
      case 'timer':
        return (GetTimers(gameDocument) ?? []).map((t) => ({
          ...t,
          name: GetTimerTitle(gameDocument, t.id)
        })) as SelectionItem[];
      default:
        return undefined;
    }
  };

  return (
    <div className={'d-flex flex-wrap'}>
      <div className={'p-2'}>
        <ComboboxInput
          disabled={disabled}
          data={Operations}
          textField={'description'}
          dataItemKey={'name'}
          className={'border border-dark w-20'}
          onChange={(e) => {
            handleChange(e);
          }}
        />
      </div>
      <div className={'d-flex py-2 gap-2'}>
        <ArgumentList
          selectedList={selectedList}
          showQuantity={showQuantity}
          argumentList={argumentList}
          onChangeArgument={props?.onChangeArgument}
          onChangeQuantity={props?.onChangeQuantity}
        />
      </div>
    </div>
  );
};
